import { render, staticRenderFns } from "./DocumentoaduaneroForm.vue?vue&type=template&id=6002e00f"
import script from "./DocumentoaduaneroForm.vue?vue&type=script&lang=js"
export * from "./DocumentoaduaneroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports